/**
 * Tailwind configuration extracted for TypeScript usage
 * This file contains the breakpoints and themes from tailwind.config.js
 */

import colors from 'tailwindcss/colors';

/**
 * Breakpoints from Tailwind config
 */
export const breakpoints = {
    'sm': '(min-width: 600px)',
    'md': '(min-width: 960px)',
    'lg': '(min-width: 1280px)',
    'xl': '(min-width: 1440px)'
};

/**
 * Themes from Tailwind config
 */
const semanticColors = {
    warn: {
        ...colors.red,
        DEFAULT: colors.red[600]
    },
    'on-warn': {
        500: colors.red[50]
    }
};

export const themes = {
    'default': {
        ...semanticColors,
        accent: {
            ...colors.red,
            DEFAULT: colors.red[800]
        },
        primary: {
            50: '#fbefef',
            100: '#f8e1e1',
            200: '#f3c3c3',
            300: '#eda0a0',
            400: '#e77171',
            500: '#e10a0e',
            600: '#dc2626',
            700: '#b5080b',
            800: '#9a070a',
            900: '#790508',
            DEFAULT: '#dc2626'
        },
        logo: 'https://api.ashcorp.xyz/assets/logo.php',
        watermark: 'https://api.ashcorp.xyz/assets/watermark.php',
        favicon: 'https://api.ashcorp.xyz/assets/favicon.php'
    },
    'slate': {
        ...semanticColors,
        accent: {
            ...colors.slate,
            DEFAULT: colors.slate[800]
        },
        primary: {
            ...colors.slate,
            DEFAULT: colors.slate[600]
        },
        logo: 'https://api.ashcorp.xyz/assets/logo.php',
        watermark: 'https://api.ashcorp.xyz/assets/watermark.php',
        favicon: 'https://api.ashcorp.xyz/assets/favicon.php'
    },
    'emerald': {
        ...semanticColors,
        accent: {
            ...colors.emerald,
            DEFAULT: colors.emerald[800]
        },
        primary: {
            ...colors.emerald,
            DEFAULT: colors.emerald[600]
        },
        logo: 'https://api.ashcorp.xyz/assets/logo.php',
        watermark: 'https://api.ashcorp.xyz/assets/watermark.php',
        favicon: 'https://api.ashcorp.xyz/assets/favicon.php'
    },
    'teal': {
        ...semanticColors,
        accent: {
            ...colors.teal,
            DEFAULT: colors.teal[800]
        },
        primary: {
            ...colors.teal,
            DEFAULT: colors.teal[600]
        },
        logo: 'https://api.ashcorp.xyz/assets/logo.php',
        watermark: 'https://api.ashcorp.xyz/assets/watermark.php',
        favicon: 'https://api.ashcorp.xyz/assets/favicon.php'
    },
    'cyan': {
        ...semanticColors,
        accent: {
            ...colors.cyan,
            DEFAULT: colors.cyan[800]
        },
        primary: {
            ...colors.cyan,
            DEFAULT: colors.cyan[600]
        },
        logo: 'https://api.ashcorp.xyz/assets/logo.php',
        watermark: 'https://api.ashcorp.xyz/assets/watermark.php',
        favicon: 'https://api.ashcorp.xyz/assets/favicon.php'
    },
    'sky': {
        ...semanticColors,
        accent: {
            ...colors.sky,
            DEFAULT: colors.sky[800]
        },
        primary: {
            ...colors.sky,
            DEFAULT: colors.sky[600]
        },
        logo: 'https://api.ashcorp.xyz/assets/logo.php',
        watermark: 'https://api.ashcorp.xyz/assets/watermark.php',
        favicon: 'https://api.ashcorp.xyz/assets/favicon.php'
    },
    'blue': {
        ...semanticColors,
        accent: {
            ...colors.blue,
            DEFAULT: colors.blue[800]
        },
        primary: {
            ...colors.blue,
            DEFAULT: colors.blue[600]
        },
        logo: 'https://api.ashcorp.xyz/assets/logo.php',
        watermark: 'https://api.ashcorp.xyz/assets/watermark.php',
        favicon: 'https://api.ashcorp.xyz/assets/favicon.php'
    },
    'indigo': {
        ...semanticColors,
        accent: {
            ...colors.indigo,
            DEFAULT: colors.indigo[800]
        },
        primary: {
            ...colors.indigo,
            DEFAULT: colors.indigo[600]
        },
        logo: 'https://api.ashcorp.xyz/assets/logo.php',
        watermark: 'https://api.ashcorp.xyz/assets/watermark.php',
        favicon: 'https://api.ashcorp.xyz/assets/favicon.php'
    },
    'violet': {
        ...semanticColors,
        accent: {
            ...colors.violet,
            DEFAULT: colors.violet[800]
        },
        primary: {
            ...colors.violet,
            DEFAULT: colors.violet[600]
        },
        logo: 'https://api.ashcorp.xyz/assets/logo.php',
        watermark: 'https://api.ashcorp.xyz/assets/watermark.php',
        favicon: 'https://api.ashcorp.xyz/assets/favicon.php'
    },
    'purple': {
        ...semanticColors,
        accent: {
            ...colors.purple,
            DEFAULT: colors.purple[800]
        },
        primary: {
            ...colors.purple,
            DEFAULT: colors.purple[600]
        },
        logo: 'https://api.ashcorp.xyz/assets/logo.php',
        watermark: 'https://api.ashcorp.xyz/assets/watermark.php',
        favicon: 'https://api.ashcorp.xyz/assets/favicon.php'
    },
    'rose': {
        ...semanticColors,
        accent: {
            ...colors.rose,
            DEFAULT: colors.rose[800]
        },
        primary: {
            ...colors.rose,
            DEFAULT: colors.rose[600]
        },
        logo: 'https://api.ashcorp.xyz/assets/logo.php',
        watermark: 'https://api.ashcorp.xyz/assets/watermark.php',
        favicon: 'https://api.ashcorp.xyz/assets/favicon.php'
    },
    'gold': {
        ...semanticColors,
        accent: {
            ...colors.amber,
            DEFAULT: colors.amber[800]
        },
        primary: {
            ...colors.amber,
            DEFAULT: colors.amber[600]
        },
        logo: 'https://api.ashcorp.xyz/assets/logo.php',
        watermark: 'https://api.ashcorp.xyz/assets/watermark.php',
        favicon: 'https://api.ashcorp.xyz/assets/favicon.php'
    }
};

/**
 * Full Tailwind config object
 */
export default {
    breakpoints,
    themes
};
